import { defineMessages } from 'react-intl-next';

export default defineMessages({
	emptyStateHeader: {
		defaultMessage: 'Looking for something?',
		description: 'Header for link picker empty state',
		id: 'hub-home.hub.link-picker.empty-state-header',
	},
	emptyStateDescription: {
		defaultMessage: 'Enter a search term to get started',
		description: 'Description for link picker empty state',
		id: 'hub-home.hub.link-picker.empty-state-description',
	},
});
